const SHARE_TOKEN_PATTERN = /^[a-f0-9]{48}$/;

export const createShareToken = () => {
  const bytes = crypto.getRandomValues(new Uint8Array(24));
  return Array.from(bytes, (byte) => byte.toString(16).padStart(2, '0')).join('');
};

export const getShareTokenFromLocation = () => {
  const match = window.location.pathname.match(/^\/share\/([^/]+)\/?$/);
  if (!match) return null;

  const token = decodeURIComponent(match[1]);
  return SHARE_TOKEN_PATTERN.test(token) ? token : null;
};
